export interface AppRoleModel {
    name: string;
    note?: string;
    normalizedName: string;
    description: string;
    id: string;
    createdAt?: Date;
    updatedAt?: Date;
    createdBy?: string;
    updatedBy?: string;
    status?: string;
  }
  
export class AppRoleModelFactory {
    static getEmpty(): AppRoleModel {
      return {
        name: "",
        note: "",
        normalizedName: "",
        description: "",
        id: "",
        createdAt: new Date(),
        updatedAt: new Date(),
        createdBy: "",
        updatedBy: "",
        status: ""
      };
    }
}
  